﻿import "./jquery-global.js";
import $ from "jquery";

export function leadFormInit() {
    $('[data-lead-form="true"]').each(function () {
        let leadFormContainer = $(this);
        let modal = leadFormContainer.closest(".modal");
        if (modal.length) {
            modal.modal("show");
        } else {
            leadFormContainer[0].scrollIntoView({ behavior: "smooth" });
        }
    });
}